import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPassword/ForgotPasswordForm';
import routeConstant from '../../lib/constants/routeConstant';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';
import middleImage from '../../assets/svgs/atlanta_logo.svg';


/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  showButton: true,
  navUrl: routeConstant.LOGIN_PAGE,
  buttonName: "Login",
  heading: "Forgot Password",
  middleImage: middleImage,
  showMiddleImage: true
}

const ForgotPasswordPage = () => {
  return (
    /* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
    to control the layout's property */
    <AuthenticationLayout options={options}>
      <ForgotPasswordForm />
    </AuthenticationLayout>
  )
}

export default ForgotPasswordPage